import { Builder } from '@builder.io/react';

import { Counter } from './index';

Builder.registerComponent(Counter, {
  name: 'Summit Counter',
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: "We're counting down",
      required: true
    },
    {
      name: 'startDate',
      type: 'date',
      required: false
    },
    {
      name: 'endDate',
      type: 'date',
      required: true
    }
  ]
});
